import React from 'react';
import { Box, LinearProgress } from '@mui/material';

const SplashScreen = () => {
  return (
    <Box
      sx={(theme) => ({
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        padding: 3,
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 2000
      })}
    >
      <Box sx={{ width: 400 }}>
        <LinearProgress />
      </Box>
    </Box>
  );
};

export default SplashScreen;
